import styled from 'styled-components';

export const Container = styled.div`
  padding: 3.6rem 3.1rem;

  #package-form {
    display: flex;
  }

  #fidelization {
    margin-left: 4rem;
    margin-top: 10rem;
    gap: 0.5rem;
  }
`;

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 5.8rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }

  @media (max-width: 425px) {
    padding: 0 4rem;
  }
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PageHeaderSaveButton = styled.button`
  font-weight: bold;
  font-size: 18px;

  width: 20%;
  height: 45px;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  @media (max-width: 768px) {
    width: 40%;
  }

  @media (max-width: 1280px) {
    width: 30%;
  }

  &:hover {
    opacity: 0.85;
    transition: 0.3s;
  }
`;

export const CardContainer = styled.ul`
  padding: 5.8rem;
  margin-bottom: 5rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  gap: 4rem;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem 0;
  }

  @media (max-width: 768px) {
    padding: 3.5rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

export const NoDataFound = styled.div`
  display: grid;
  place-items: center;

  height: 50vh;

  h1 {
    color: #ffdf22;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 28px;

  width: 350px;

  @media (max-width: 425px) {
    width: 100%;
  }

  #input-currency {
    border-radius: 4rem;
    background: #ffffff;
    color: #000000;
    padding: 1.6rem 3.4rem;
  }''
`;

export const RadioContainer = styled.label`
  /* padding-left: 17px; */
  color: #fff;
  display: flex;
  gap: 1rem;
`;

export const FormLabel = styled.label`
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  padding: 0 17px;
  margin-bottom: 5px;
`;

export const SelectContainer = styled.div`
  div {
    border-radius: 2rem;
  }
`;

export const CreatePackageButton = styled.button`
  background-color: ${({ theme }) => theme.colors.yellow};

  margin: 3rem 0 0 5.8rem;
  padding: 1rem 6rem;
  height: 5.8rem;

  font-size: 2.2rem;
  text-transform: uppercase;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  background: linear-gradient(107deg, #ffd503 0%, #ffdf22 100%);
  border-radius: 5rem;

  transition: 180ms ease-in;

  &:hover {
    opacity: 0.85;
  }
`;
